export const SmsIcon = ({
  strokeColor = "var(--color-txt-secondary)",
  ...props
}: any) => (
  <svg width={16} height={16} fill="none" {...props}>
    <path
      fill="var(--color-icon-bright)"
      d="M11.333 14.165H4.667c-2.434 0-3.834-1.4-3.834-3.833V5.665c0-2.433 1.4-3.833 3.834-3.833h6.666c2.434 0 3.834 1.4 3.834 3.833v4.667c0 2.433-1.4 3.833-3.834 3.833ZM4.667 2.832c-1.907 0-2.834.927-2.834 2.833v4.667c0 1.907.927 2.833 2.834 2.833h6.666c1.907 0 2.834-.926 2.834-2.833V5.665c0-1.906-.927-2.833-2.834-2.833H4.667Z"
    />
    <path
      fill="var(--color-icon-bright)"
      d="M8 8.58c-.56 0-1.127-.173-1.56-.527L4.353 6.387a.499.499 0 0 1 .62-.78L7.06 7.273c.507.407 1.367.407 1.873 0l2.087-1.666a.492.492 0 0 1 .7.08.492.492 0 0 1-.08.7L9.553 8.053c-.426.354-.993.527-1.553.527Z"
    />
  </svg>
);
